import { Link, useLocation } from 'react-router-dom';
import { ConfigProvider, Flex, Menu } from 'antd';
import styles from "./MainMenu.module.css"
import navigation from '../json/navigation.json';

const MainMenu = () => {
  const key = useLocation().pathname;

  const getLink = (route, label, color) => {
    return (
      <Link key={route} to={route} onClick={changeBgColor.bind(this, color)}>
        <span>{label}</span>
      </Link>
    );
  };

  const changeBgColor = color => {
    document.body.style.backgroundColor = color;
  }

  const getItems = (items) => {

    return items.map((entry) => { 
      if(key === entry.key) {
        changeBgColor(entry.bgColor);
      }
      return {
        key: `${entry.key}`,
        ...(entry.route ? { label: getLink(entry.key, entry.label, entry.bgColor) } : { label: entry.label }),
        ...(entry.children && { children: getItems(entry.children) }),
        ...(entry.parent ? { style: { fontWeight: 'normal', fontSize: '1.25em' } } : { style: { fontWeight: 'normal', fontSize:'1em' } }),
      }
    });
  };

  const items = getItems(navigation);

  return (
    <ConfigProvider
    theme={{
      components: {
        Menu: {
          popupBg: document.body.style.backgroundColor,
          itemActiveBg: document.body.style.backgroundColor,
          itemSelectedBg: 'inherit',
        },
      }
    }}>
      <Flex justify='space-between' align='center' className={styles.container} style={{backgroundColor: document.body.style.backgroundColor}}>
        <Menu
          mode="horizontal"
          className={styles.menu}
          selectedKeys={[useLocation().pathname]}
          items={items}
          onSelect={changeBgColor.bind(this)}/>
        <img src='logo-small.png' style={{height:'100px'}}/>
      </Flex>
    </ConfigProvider>
  );
};

export default MainMenu;
